package com.fireavert.gateways.gateway_dialog.client.presentation

data class GatewayDialogViewState(
    val loading: Boolean = true,
    val imageUploading: Boolean = true,
    val imageUploadError: String = "",
    val gatewayImages: Map<Int, String> = emptyMap(),
)
